import React from 'react';
import { FormikProps } from 'formik';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppFormSelectWrapper from '../../../components/designe/app-form-select-wrapper';

interface ISubscriptionPlanPricesFilterProps {
  formik: FormikProps<any>;
  filterCurrentOptions: Array<{ id: string | boolean; name: string }>;
}

export function SubscriptionPlanPricesFilter(
  props: ISubscriptionPlanPricesFilterProps,
) {
  const { formik, filterCurrentOptions } = props;
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.current')}
          name="current"
          options={filterCurrentOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
    </Grid>
  );
}
